<ng-container *transloco="let t; prefix: 'PremiseHazard'">
  <!-- TODO: Test the Advanced Address Lookup dialog: required validation, geocode submit, cancel, layout responsiveness. -->
  <form [formGroup]="GeocodeForm">
    <div class="verify-address-container">
      <div class="verify-address-row">
        <div>
          <label class="msi-label">{{ t('label.locationName') }}</label>
          <div class="input-container">
            <input pInputText class="full-width-input" placeholder="{{ t('placeholder.locationNameExample') }}" formControlName="locationName" />
          </div>
        </div>
        <div>
          <label class="msi-label">{{ t('label.address') }}</label>
          <div class="input-container">
            <input pInputText class="full-width-input" placeholder="{{ t('placeholder.addressExample') }}" formControlName="address" />
          </div>
        </div>
      </div>
      <div class="verify-address-row">
        <div>
          <label class="msi-label">{{ t('label.city') }}</label>
          <div class="input-container">
            <input pInputText class="full-width-input" placeholder="{{ t('placeholder.city') }}" formControlName="city" />
          </div>
        </div>
        <div>
          <label class="msi-label">{{ t('label.zipCode') }}</label>
          <div class="input-container">
            <input pInputText class="full-width-input" placeholder="{{ t('placeholder.zipCode') }}" formControlName="zipCode" />
          </div>
        </div>
      </div>
      <div class="verify-address-row">
        <div>
          <label class="msi-label">{{ t('label.building') }}</label>
          <div class="input-container">
            <input pInputText class="full-width-input" placeholder="{{ t('placeholder.building') }}" formControlName="building" />
          </div>
        </div>
        <div>
          <label class="msi-label">{{ t('label.apartmentNumber') }}</label>
          <div class="input-container">
            <input pInputText class="full-width-input" placeholder="{{ t('label.apartmentNumber') }}" formControlName="apartment" />
          </div>
        </div>
      </div>
      <div class="verify-address-row">
        <div>
          <label class="msi-label">{{ t('label.floor') }}</label>
          <div class="input-container">
            <input pInputText class="full-width-input" placeholder="{{ t('placeholder.floor') }}" formControlName="floor" />
          </div>
        </div>
        <div>
          <label class="msi-label">{{ t('label.subdivision') }}</label>
          <div class="input-container">
            <input pInputText class="full-width-input" placeholder="{{ t('placeholder.subdivision') }}" formControlName="subdivision" />
          </div>
        </div>
      </div>
    </div>
    @if (processing) {
      <div class="form-row-bottom">
        <p-progress-spinner />
      </div>
    } @else {
      <div class="form-row-bottom">
        <button type="button" pButton [outlined]="true" (click)="onCancel()">
          <msi-icon name="ic_remove" class="delete-icon" />{{ 'Buttons.cancel' | transloco }}
        </button>
        <button type="button" pButton (click)="onSubmit()" [disabled]="!GeocodeForm.valid">
          <msi-icon name="ic_search" />{{ t('Item.modal.advancedLookup.geocodeButton') }}
        </button>
      </div>
    }
  </form>
</ng-container>
